"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERegions = {
    moscow: 1,
    moscowArea: 4593,
    spb: 2,
    spbArea: 4588,
};
exports.PrimaryMetroRegions = [
    exports.ERegions.moscow,
    exports.ERegions.moscowArea,
    exports.ERegions.spb,
    exports.ERegions.spbArea,
];
var ELocationTypeId;
(function (ELocationTypeId) {
    ELocationTypeId[ELocationTypeId["City"] = 1] = "City";
})(ELocationTypeId = exports.ELocationTypeId || (exports.ELocationTypeId = {}));
//# sourceMappingURL=offer.js.map